import Model, { attr } from '@ember-data/model';
import { htmlSafe } from '@ember/template';

export default class OrgSettingModel extends Model {
  @attr('boolean') declare incomeOnly: boolean;
  @attr('boolean') declare canOverrideRolePerFund: boolean;
  @attr('boolean') declare pbtOrg: boolean;
  @attr('boolean') declare userCanCancel: boolean;
  @attr('number') ytdStartAtMonth?: number;
  @attr() manualTransactionTypes?: string[];
  @attr('string') footerHtml?: string;
  @attr('boolean') hideMonthlyBalance!: boolean;

  get footerHtmlSafe() {
    return htmlSafe(this.footerHtml || '');
  }
}
